import { Link } from "react-router-dom";

export function NotFound () {
    return (
        <div className='container fadeIn'>
            <h1 className='mt-5'>404 Pagina Não Encontrada!</h1>
            <p className='mt-3'>
                <Link to={`${process.env.PUBLIC_URL}/}`} >Volte para o Inicio!</Link>
            </p>
        </div>
    ) 
} 